import { theme } from '@/theme';

export const styles = {
  headerWrapper: {
    background: 'rgba(255, 255, 255, 0.9)',
    backdropFilter: 'blur(10px)',
    borderBottom: `1px solid ${theme.colors.border}`,
    position: 'sticky' as const,
    top: 0,
    zIndex: 1000,
    padding: `${theme.spacing.md} 32px`,
  },

  container: {
    maxWidth: '1280px',
    margin: '0 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontFamily: theme.typography.fontFamily,
  },

  logoLink: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    textDecoration: 'none',
  },

  logoBox: {
    width: '36px',
    height: '36px',
    borderRadius: theme.radius.md,
    background: 'linear-gradient(135deg, #7367F0 0%, #9E95F5 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.colors.text.inverse,
    fontWeight: theme.typography.fontWeight.extrabold,
    fontSize: '1.1rem',
    boxShadow: theme.shadows.primary,
  },

  logoTextHeading: {
    color: theme.colors.text.heading,
    fontWeight: theme.typography.fontWeight.bold,
    fontSize: '1.05rem',
    lineHeight: 1.2,
  },

  logoTextHighlight: {
    color: theme.colors.primary,
  },

  logoTextSub: {
    color: theme.colors.text.muted,
    fontSize: '0.6875rem',
    fontWeight: theme.typography.fontWeight.medium,
  },

  nav: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
  },

  navLink: {
    color: theme.colors.text.body,
    textDecoration: 'none',
    fontSize: theme.typography.fontSize.sm,
    fontWeight: theme.typography.fontWeight.medium,
  },

  navLinkAi: {
    color: theme.colors.primary,
    textDecoration: 'none',
    fontSize: theme.typography.fontSize.sm,
    fontWeight: theme.typography.fontWeight.semibold,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.xs,
  },

  actionsGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },

  btnSignIn: {
    background: 'transparent',
    color: theme.colors.text.heading,
    border: `1px solid ${theme.colors.border}`,
    padding: '8px 16px',
    borderRadius: theme.radius.sm,
    fontWeight: theme.typography.fontWeight.semibold,
    fontSize: theme.typography.fontSize.xs,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    transition: `all ${theme.animations.transitionBase}`,
  },

  btnRegister: {
    background: theme.colors.primary,
    color: theme.colors.text.inverse,
    border: 'none',
    padding: '8px 16px',
    borderRadius: theme.radius.sm,
    fontWeight: theme.typography.fontWeight.bold,
    fontSize: theme.typography.fontSize.xs,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    boxShadow: theme.shadows.primary,
    transition: `all ${theme.animations.transitionBase}`,
  },
} as const;
